import { simCardType } from '../config/simcard-types';
import { CHOOSE_SIM_TYPE } from '../constants/choose-sim-type';
import { KeyValue } from '../types/common.types';

export const getIfESimOrder = (state: KeyValue): boolean => {
  const productOrder = state?.order?.productOrder;
  const cartOrder = state?.cart?.order;

  return (
    productOrder?.sim?.selectedSimType === CHOOSE_SIM_TYPE.SIM_TYPE_ESIM ||
    cartOrder?.newlyAddedSimDetails?.simDetails?.simType ===
      simCardType.simTypeESim
  );
};

export const getIfCISMyInfoFlow = (state: KeyValue): boolean => {
  const cisInformation = state.user?.cis?.information;
  if (!cisInformation) {
    return false;
  }

  const isCisUserLoginTypeMyInfo = Boolean(cisInformation?.$myInfo);
  const isCISFlow = Boolean(cisInformation?.rates);
  const userCISMyInfo = Boolean(cisInformation?.cusMyInfo);

  return isCISFlow && isCisUserLoginTypeMyInfo && userCISMyInfo;
};
